import {SELECIONAR_DESCONTO_USUARIO_ROTA } from '../../actions/types'

const initialState = null

export default function reducerDescontoUsuarioRotaSelecionado (state = initialState, action ) {
  switch (action.type) {
    case SELECIONAR_DESCONTO_USUARIO_ROTA: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
